export class ItsAuthV2 {
  itsAuth: string

  constructor(itsAuth: string) {
    this.itsAuth = itsAuth
  }
}
